let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2wrfo")).then(() => parcelRequire('dqjML'));